export default __webpack_public_path__ + "static/security-scan-37b94590de6be8bcbb783b476e9c681d.png";